import React from 'react';

function Footer() {
  return (
    <footer
      style={{
        borderTop: '1px solid var(--border)',
        padding: '2rem 3.5rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: '0.8rem',
        color: 'var(--muted)',
        fontSize: '0.85rem',
      }}
    >
      <span
        style={{
          fontFamily: "'Syne', sans-serif",
          fontWeight: 800,
          background: 'linear-gradient(135deg, #4d94ff, #a78bfa)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          fontSize: '1.1rem',
        }}
      >
        Zachary Djerdjouri
      </span>

      <span>Built with React.js &amp; Bootstrap · © {new Date().getFullYear()}</span>

      <span style={{ color: 'var(--blue-light)' }}>zdjer050@uottawa.ca</span>
    </footer>
  );
}

export default Footer;
